import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from 'react-oidc-context';
import { AppRouter } from './core/routes/AppRouter';
import { CartProvider } from './modules/venta/application/context/CartContext';
import { SessionProvider } from './core/context/SessionContext';
import { AuthGuard } from './core/components/AuthGuard';

const oidcConfig = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL ?? 'https://cmautenticacion-dev.coordinadora.com'}/realms/${process.env.REACT_APP_KEYCLOAK_REALM ?? 'autenticacion_usuarios'}`,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? 'sigo-cli',
  redirect_uri: `${globalThis.location.origin}/select-terminal`,
  post_logout_redirect_uri: `${globalThis.location.origin}/login`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#0066cc', // Azul Coordinadora
    },
    secondary: {
      main: '#eb5d2c', // Naranja Coordinadora
    },
    success: {
      main: '#eb5d2c', // Usamos el naranja para acciones principales/éxito
      contrastText: '#fff',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function App() {
  return (
    <AuthProvider {...oidcConfig}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SessionProvider>
          <CartProvider>
            <AuthGuard>
              <AppRouter />
            </AuthGuard>
          </CartProvider>
        </SessionProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
